<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-7 header_btn"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'vendors/edit/'+selectedRows[0].vendor_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'vendors/edit/'+selectedRows[0].vendor_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon  dark v-bind="attrs" v-on="on">
                <v-badge overlap dot :value="search || pagination.filters.alphabet" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Filter</span>
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.item_active"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Documents</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Logs</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length < 1 || open_doc_model_falg || open_log_model_falg"
                @click="getVendorBalance('multi','')"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-calculator-variant-outline</v-icon>
                <span class="lable_class">Balance</span>
              </v-btn>
            </template>
            <span>Balance</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Vendor
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff  !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background:none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                :style="alphabet.text == 'Z' 
                  ? 'padding-top: 1px !important; padding-bottom: 11px !important;' 
                  : 'padding-bottom: 2px !important;'"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:14px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value) ? 'primary' : ''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{ alphabet.text }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              item-key="vendor_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item, index }">
                <tr :class="(!item.active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon
                      v-if="item.is_system_vendor != 1"
                      @click="editRecord(item.vendor_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%" class="pl-2">
                    <v-simple-checkbox
                      v-if="item.is_system_vendor != 1"
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                      @input="selectRecord(item.vendor_id)"
                    ></v-simple-checkbox>
                  </td>
                  <td width="25%">{{item.v_name}}</td>
                  <td width="9.5%">{{item.mobile}}</td>
                  <td width="18%">{{item.contact_person}}</td>
                  <td width="21.5%">
                    <v-autocomplete
                      style="margin-top: -1px;"
                      dense
                      hide-details
                      v-model="item.bank_id"
                      :items="bank_list"
                      item-text="bank_name"
                      item-value="bank_id"
                      @change="updateExpenseType(index)"
                    >
                      <!-- <template v-slot:selection="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{ item.bank_code }}</span>
                          </template>
                          <span>{{ item.bank_name }}</span>
                        </v-tooltip>
                      </template>-->
                    </v-autocomplete>
                  </td>
                  <td width="8.5%" class="text-right">
                    <span
                      v-if="item.vendor_balance_flag==true"
                      :class="{
                        'error--text': item.amt_due   < 0,
                        'primary--text': item.amt_due > 0,
                      }"
                    >{{item.amt_due!=0 ? '$'+ getAmountFormat(item.amt_due) : ''}}</span>
                    <v-btn
                      icon
                      x-small
                      v-else
                      href
                      class="pr-7"
                      @click="getVendorBalance('single',item.vendor_id)"
                    >view</v-btn>
                  </td>
                  <td width="4.5%" class="pl-6">{{(item.active)?'Yes':'No'}}</td>
                  <td width="4.5%" class="pl-4">{{(item.email_alert)?'Yes':'No'}}</td>
                  <td width="2.5%">
                    <v-icon
                      @click="editRecord(item.vendor_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected vendors?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteVendor()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Add />
    <Edit />
    <Upload />
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import Upload from "../document/Upload";
import DocList from "../document/List";
import LogList from "../log/List";
import { mapMutations, mapState } from "vuex";
import { parseParams, logout } from "../../plugins/helper";
export default {
  name: "VendorList",
  data() {
    return {
      open_doc_model_falg: false,
      open_log_model_falg: false,
      search: "",
      bank_list: [],
      loading: false,
      delete_dialog: false,
      expanded: [],
      items: {
        data: []
      },
      filter_menu: false,
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["v_name"],
        page: 1,
        filters: {
          item_active: "1",
          alphabet: ""
        }
      },
      alphabets: [],
      search_menu: false,
      dateFormatted: null,
      dateFormatted2: null
    };
  },
  components: {
    Add,
    Edit,
    Upload,
    LogList,
    DocList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("vendor", ["add_modal", "edit_modal"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "v_name";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto"
        };
      } else {
        return {};
      }
    },
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "3%" },
        {
          value: "checkbox",
          text: "#",
          sortable: false,
          width: "3%",
          class: "pl-3"
        },
        { value: "v_name", text: "Vendor Name", sortable: true, width: "25%" },
        { value: "", text: "Mobile", sortable: false, width: "9.5%" },
        { value: "", text: "Contact Person", sortable: false, width: "18%" },
        { value: "", text: "Expense Type", sortable: false, width: "21.5%" },
        {
          value: "",
          text: "Balance",
          sortable: false,
          width: "8.5%",
          align: "right"
        },
        { value: "", text: "Active", sortable: false, width: "4.5%" },
        { value: "", text: "Alert", sortable: false, width: "4.5%" },
        { value: "", text: "", sortable: false, width: "2.5%" }
      ];
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getVendors();
    },
    pagination: {
      handler: function() {
        this.getVendors();
      },
      deep: true
    },
    add_modal: function(value) {
      if (!value) {
        this.pagination.filters.alphabet = "";
        this.resetFilter();
      }
    },
    edit_modal: function(value) {
      if (!value) {
        this.getVendors();
      }
    }
  },
  methods: {
    ...mapMutations("vendor", ["setData"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    updateExpenseType(index) {
      axios
        .post("inline_edit_vendor", this.items.data[index])
        .then(function() {})
        .catch(function(error) {
          console.log("FAILURE!!", error);
        });
    },
    getBank() {
      let _self = this;
      axios
        .get(
          "account_list?itemsPerPage=-1&filter[account_type]=21&sortBy=bank_name"
        )
        .then(response => {
          _self.bank_list = response.data.data.data;
        })
        .catch(function() {});
    },
    resetFilter() {
      this.search = "";
      this.pagination.filters.item_active = "1";
      this.getVendors();
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.vendor_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    openUploader(item) {
      this.setModal(true);
      this.setDocumentData({ key: "type", value: 2 });
      this.setDocumentData({ key: "o_id", value: item.vendor_id });
      this.setDocumentData({ key: "items", value: this.items });
      this.setDocumentData({ key: "item", value: item });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 2 });
      this.setDocumentData({ key: "o_id", value: item.vendor_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Vendor" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "VENDOR" });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: "" });
      this.setDocumentData({ key: "vendor_name", value: item.v_name });
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 2 });
      this.setLogData({ key: "o_id", value: item.vendor_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Vendor" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: "" });

      this.setLogData({ key: "bank_name", value: "" });

      this.setLogData({ key: "project_name", value: "" });

      this.setLogData({ key: "vendor_name", value: item.v_name });
    },
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    addRecord() {
      this.setData({ key: "add_modal", value: true });
    },
    editRecord(vendor_id, is_view_mode) {
      this.setData({ key: "edit_modal", value: true });
      this.setData({ key: "id", value: vendor_id });
      this.setData({ key: "is_view_mode", value: is_view_mode });
    },
    ...mapMutations("utils", ["setAlert"]),
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=vendor").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.vendor_id == itemData.item.vendor_id) {
            item.expande_icon = "mdi-chevron-up";
            item.selected = true;
          } else {
            item.expande_icon = "mdi-chevron-down";
          }
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.expande_icon = "mdi-chevron-down";
          return item;
        });
      }
    },
    getVendorType(vendorTypes) {
      let types = vendorTypes.map(item => {
        return item.type.vendor_type;
      });
      return types.join(", ");
    },
    deleteVendor() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.vendor_id);
      });
      axios
        .post("delete_vendor", {
          ids: ids
        })
        .then(function(response) {
          if (response.data.message != "") {
            _self.setAlert({
              show: true,
              variant: "error",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
          _self.getVendors();
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getVendorBalance(type, id) {
      let _self = this;
      this.loading = "accent";
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.selectedRows.map(function(item) {
          ids.push(item.vendor_id);
        });
      }
      axios
        .get("get_vendor_balance?vendor_ids=" + ids)
        .then(response => {
          this.items.data = this.items.data.filter(item => {
            response.data.data.filter(fil => {
              if (item.vendor_id == fil.vendor_id) {
                console.log("amt_due", fil.amt_due);
                item.amt_due = fil.amt_due;
                item.vendor_balance_flag = true;
              }
            });
            return item;
          });
          this.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getVendors() {
      let _self = this;
      let url = parseParams(this.pageData);
      this.loading = "accent";
      axios
        .get("vendor_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.alphabets = response.data.alphabets;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    //this.getAlphabets();
    this.getBank();
  }
};
</script>

<style>
</style>